import { useState } from 'react';
import { Box, Button, Chip, Divider, Stack, Typography } from '@mui/joy';
import { formatRating } from '../../../utils/rating';
import ReadyMetrics, { duration } from './ReadyMetrics';

const date = value => value ? new Date(value).toLocaleString('ru-RU') : 'Нет данных';
const status = { active: 'Активен', cancelled: 'Отменён', completed: 'Завершён' };
export default function CompletedMetrics({ metrics }) {
  const [open, setOpen] = useState(false);
  if (!metrics) return null;
  return <Box onClick={e => e.stopPropagation()} sx={{ mt: 1, border: '1px solid', borderColor: 'success.200', borderRadius: 'lg', p: 1 }}>
    <Typography level="title-sm">Итоги события</Typography>
    <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 0.75 }}>
      <Chip size="sm" color="success" variant="soft">Полный цикл: {duration(metrics.total_seconds)}</Chip>
      <Chip size="sm" variant="soft">Кругов КК: {metrics.qa_rounds || 0}</Chip>
      <Chip size="sm" color="warning" variant="soft">Допобмеров: {metrics.additional_count || 0}</Chip>
      <Chip size="sm" variant="soft">Отзывов чертёжников: {metrics.peer_reviews?.length || 0}</Chip>
      <Chip size="sm" variant="soft">Оценок клиентов: {metrics.client_ratings?.length || 0}</Chip>
    </Stack>
    <Button size="sm" variant="plain" onClick={() => setOpen(v => !v)} sx={{ mt: 0.5 }}>{open ? 'Скрыть подробности' : 'Время, круги и оценки'}</Button>
    {open && <Stack spacing={1} sx={{ mt: 1 }}>
      <Typography level="body-xs">Создано: {date(metrics.created_at)}<br/>Завершено: {date(metrics.completed_at)}</Typography>
      <ReadyMetrics metrics={metrics.ready} completed />
      <Divider>Проверки качества</Divider>
      {metrics.qa_reviews?.map(row => <Box key={row.id}>
        <Typography level="body-sm">Круг {row.round} · {row.verdict} · {formatRating(row.score)} ★</Typography>
        <Typography level="body-xs">{row.author} · {date(row.at)}</Typography>
        <Typography level="body-xs">Черчение: {duration(row.drawing_seconds)} · КК: {duration(row.qa_seconds)}</Typography>
        {row.rework_wait_seconds != null && <Typography level="body-xs">До принятия доработки: {duration(row.rework_wait_seconds)}</Typography>}
        {row.rework_accepted_at && <Typography level="body-xs">Доработка принята: {date(row.rework_accepted_at)}</Typography>}
        {row.comment && <Typography level="body-sm" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{row.comment}</Typography>}
      </Box>)}
      {!metrics.qa_reviews?.length && <Typography level="body-xs">История КК для старого события отсутствует</Typography>}
      {metrics.quality_rating && <Typography level="body-sm">Оценка КК: {formatRating(metrics.quality_rating.score)} · {metrics.quality_rating.author} {metrics.quality_rating.comment}</Typography>}
      <Divider>Оценки обмера</Divider>
      {metrics.peer_reviews?.map(row => <Box key={row.id}>
        <Typography level="body-sm">{row.author} → {row.subject}: {formatRating(row.score)} ★</Typography>
        <Typography level="body-xs">ТЗ {formatRating(row.quality_tz)} · Качество {formatRating(row.quality)} · Отклик {formatRating(row.response)}</Typography>
        <Typography level="body-xs">{date(row.at)}</Typography>
        {row.comment && <Typography level="body-sm" sx={{ overflowWrap: 'anywhere' }}>{row.comment}</Typography>}
      </Box>)}
      {!metrics.peer_reviews?.length && <Typography level="body-xs">Отзывов нет</Typography>}
      <Divider>Оценки клиентов</Divider>
      {metrics.client_ratings?.map(row => <Box key={row.application_id}>
        <Typography level="body-sm">Заявка №{row.application_id}</Typography>
        <Typography level="body-xs">Обмерщик {formatRating(row.surveyor)} · Чертёжник {formatRating(row.draftsman)} · Менеджер {formatRating(row.manager)}</Typography>
        <Typography level="body-xs">{date(row.at)}</Typography>
        {row.comment && <Typography level="body-sm" sx={{ overflowWrap: 'anywhere' }}>{row.comment}</Typography>}
      </Box>)}
      {!metrics.client_ratings?.length && <Typography level="body-xs">Клиент пока не оценил работу</Typography>}
      {!!metrics.additional_cycles?.length && <Divider>Циклы допобмера</Divider>}
      {metrics.additional_cycles?.map(row => <Box key={row.id}>
        <Typography level="body-sm">Допобмер №{row.id} · {status[row.status] || row.status}</Typography>
        <Typography level="body-xs">{row.scheduled || date(row.started_at)}<br/>Принят: {date(row.accepted_at)}<br/>Завершён: {date(row.completed_at || row.cancelled_at)}</Typography>
        <Typography level="body-sm" sx={{ overflowWrap: 'anywhere' }}>{row.reason}</Typography>
      </Box>)}
    </Stack>}
  </Box>;
}
